export default __webpack_public_path__ + "static/media/air_Products.1a01fee3.png";